import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoPasskey40 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M19.9977 21.6667C13.6717 21.6667 9.05424 25.8725 7.78364 31.5262C7.56831 32.4843 8.34633 33.3333 9.32843 33.3333H23.331M25.831 10.8333C25.831 14.055 23.2193 16.6667 19.9977 16.6667C16.776 16.6667 14.1644 14.055 14.1644 10.8333C14.1644 7.61167 16.776 5 19.9977 5C23.2193 5 25.831 7.61167 25.831 10.8333Z" stroke={iconColor} strokeWidth={3.333} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M30 18.3334C27.2385 18.3334 25 20.5719 25 23.3334C25 25.3512 26.1953 27.09 27.9167 27.88V33.7662C27.9167 34.0194 28.0317 34.2587 28.2295 34.4169L29.4795 35.4169C29.7838 35.6604 30.2162 35.6604 30.5205 35.4169L31.7705 34.4169C31.9683 34.2587 32.0833 34.0194 32.0833 33.7662V32.3784L30.8333 31.25L32.0833 30V27.88C33.8047 27.09 35 25.3512 35 23.3334C35 20.5719 32.7615 18.3334 30 18.3334ZM28.3333 23.3334C28.3333 22.4129 29.0795 21.6667 30 21.6667C30.9205 21.6667 31.6667 22.4129 31.6667 23.3334C31.6667 24.2539 30.9205 25 30 25C29.0795 25 28.3333 24.2539 28.3333 23.3334Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoPasskey40;